<div
  class="thi-landing-root min-h-screen bg-background text-foreground"
  [attr.dir]="dir"
  [class.font-inter]="fontClass === 'font-inter'"
  [class.font-cairo]="fontClass === 'font-cairo'"
  [class.font-heebo]="fontClass === 'font-heebo'"
>
  <app-thi-campaign-header
    [lang]="landingLang"
    (scrolledPastHero)="onScrolledPastHero($event)"
    (langChange)="onLangFromHeader($event)"
  ></app-thi-campaign-header>
  <app-thi-campaign-main [lang]="landingLang" [showStickyCta]="showStickyCta"></app-thi-campaign-main>
  <app-thi-landing-footer [lang]="landingLang"></app-thi-landing-footer>
</div>
